import { breakpointsTailwind } from "@vueuse/core";
import type { LegacySearchMethodProps, SearchMethodParams, SearchParams } from "algoliasearch/lite";

export type SearchAnalyticsSourceType = "autocomplete" | "search" | "new-products";

const mergeTags = (source: SearchAnalyticsSourceType, tags: string[] = []) => {
  const viewportTag = window.innerWidth >= breakpointsTailwind.lg ? "desktop" : "mobile";
  return [...new Set([...tags, source, viewportTag])];
};

export const addSearchAnalyticsTagsToParams = (
  params: SearchParams = {},
  source: SearchAnalyticsSourceType,
): SearchParams => {
  if ("params" in params && typeof params.params === "string") {
    const searchParams = new URLSearchParams(params.params);
    const encodedTags = searchParams.get("analyticsTags");
    const tags: unknown = encodedTags === null ? [] : JSON.parse(encodedTags);
    if (!Array.isArray(tags) || !tags.every((tag): tag is string => typeof tag === "string")) {
      throw new TypeError("Algolia analyticsTags must be an array of strings.");
    }
    searchParams.set("analyticsTags", JSON.stringify(mergeTags(source, tags)));
    return { ...params, params: searchParams.toString() };
  }

  return {
    ...params,
    analyticsTags: mergeTags(source, "analyticsTags" in params ? params.analyticsTags : undefined),
  };
};

export const addSearchAnalyticsTags = (
  params: SearchMethodParams | LegacySearchMethodProps,
  source: SearchAnalyticsSourceType,
): SearchMethodParams | LegacySearchMethodProps => {
  if (Array.isArray(params)) {
    return params.map((request) => ({
      ...request,
      params: { ...request.params, analyticsTags: mergeTags(source, request.params?.analyticsTags) },
    }));
  }

  return {
    ...params,
    requests: params.requests.map((request) => ({ ...request, ...addSearchAnalyticsTagsToParams(request, source) })),
  };
};
